export const routePage = (history, type) => {
  return history.push(type);
};
